import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/clinical-md-cro-neurology")({
  head: () => buildRouteHead("/clinical-md-cro-neurology", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/full-service-medical-device-cro", replace: true });
  },
});
